import { Box, Divider, Typography } from "@mui/material";
import { SecaoLegal } from "../Legal/secoes";
import { DocumentoLegal } from "../Legal/tipos";

interface SecaoDocumentoProps {
  secao: SecaoLegal;
  documento: DocumentoLegal;
}

const formatarData = (iso: string): string =>
  new Date(iso).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

// O HTML vem do campo `content`, editado só por admins na tela de Configuração.
const estilosDoConteudo = {
  color: "text.primary",
  "& h2": { fontSize: "1.25rem", fontWeight: 700, marginTop: "28px" },
  "& h3": { fontSize: "1.05rem", fontWeight: 700, marginTop: "22px" },
  "& p": { marginBottom: "14px", lineHeight: 1.7, textAlign: "justify" },
  "& ul, & ol": { marginLeft: "24px", marginBottom: "14px" },
  "& li": { lineHeight: 1.7, marginBottom: "6px" },
  "& a": { color: "primary.dark", wordBreak: "break-word" },
  "& table": { width: "100%", borderCollapse: "collapse" },
  "& td, & th": { border: "1px solid #e0e0e0", padding: "8px" },
  "& img": { maxWidth: "100%" },
};

/** Um documento legal: título ancorável, versão, data e o conteúdo em HTML. */
const SecaoDocumento = ({ secao, documento }: SecaoDocumentoProps) => (
  <Box component="section" id={secao.ancora} sx={{ scrollMarginTop: "16px" }}>
    <Divider sx={{ marginY: 3 }} />
    <Typography variant="h2" sx={{ fontSize: { xs: "1.5rem", md: "1.75rem" } }}>
      {secao.titulo}
    </Typography>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      Versão {documento.version} · atualizada em{" "}
      {formatarData(documento.updatedAt)}
    </Typography>
    <Box
      sx={estilosDoConteudo}
      dangerouslySetInnerHTML={{ __html: documento.content }}
    />
  </Box>
);

export default SecaoDocumento;
